<template>
  <Layout title="Todo">
    <Title
      icon="check"
      heading="To Do List"
      sub-heading="Things you need to be aware of and actions to complete."
    />

    <div class="container">
      <div class="row">
        <div class="col">
          <div v-if="!notifications.data.length">
            <div class="card mt-5">
              <div class="card-body">
                <div class="card-text text-center">
                  You don't currently have any items in your To Do list. When
                  people assign Contracts to you, the action items will appear
                  here.
                </div>
              </div>
            </div>
          </div>
          <table v-else class="mt-5 table table-striped">
            <thead>
              <tr>
                <th class="border-top-0" scope="col"></th>
                <th class="border-top-0" scope="col">Item</th>
                <th class="border-top-0" scope="col">Counterparty</th>
                <th class="border-top-0" scope="col">Type</th>
                <th class="border-top-0" scope="col">Action</th>
              </tr>
            </thead>
            <Notification
              v-for="(notification, index) in notifications.data"
              :key="notification.id"
              :index="index"
              :notification="notification"
            />
          </table>
        </div>
      </div>
    </div>

    <div class="container">
      <Pagination :links="notifications.links" />
    </div>
  </Layout>
</template>

<script>
import Layout from '@/Shared/Layout';
import Title from '@/Shared/Title';
import Pagination from '@/Shared/Pagination';
import Notification from '@/Pages/Notifications/Notification';

export default {
  components: {
    Layout,
    Title,
    Pagination,
    Notification,
  },

  props: {
    notifications: {
      type: Object,
      default: () => [],
    },
  },

};
</script>
